
import { defineComponent } from "vue";
import { Aemet } from "@/types/aemet.type";
import { Filter } from "@/types/filter.type";
import { getAemet } from "@/service/aemet.service";
import { getLastData } from "@/service/aemetHistory.service";
import { dateFormatDate } from "@/utils/date.utils";

export default defineComponent({
  components: {},
  props: {},
  data() {
    return {
      items: [] as Aemet[],
      query: "" as string,
      currentPage: 1 as number,
      hasMore: true,
    };
  },
  mounted() {
    this.currentPage = 1;
    this.refreshItems();
  },
  methods: {
    dateFormatDate,
    async showMore() {
      const filter: Filter = {};
      this.hasMore = false;
      const rowPerPage = 10;
      if (this.query) {
        filter.multi = this.query;
      }

      const { data, totalRows } = await getAemet(this.currentPage, rowPerPage, filter);

      // - concat result array
      this.items = [...this.items, ...data];

      // - check if exist more result
      this.hasMore = totalRows > this.currentPage * rowPerPage;
      this.currentPage++;
    },

    async refreshItems(item: Aemet | undefined = undefined) {
      let index = -1;
      if (this.items && item) {
        index = this.items.findIndex((i) => i.id === item.id);
      }
      if (index !== -1 && item) {
        this.items[index] = item;
      } else {
        this.items = [];
        this.currentPage = 1;
        await this.showMore();
      }
    },

    getMagnitude(info: any) {
      return [
        { magnitude: "Pluviometría", value: info.pluviometry },
        { magnitude: "Presión", value: info.pressure },
        { magnitude: "Temperatura ambiente", value: info.roomTemperature },
        { magnitude: "Viento", value: info.wind },
      ];
    },
    async getHistory(item: Aemet) {
      let lastData;
      if (item.code) {
        lastData = await getLastData(item.code);
      }

      item.aemetHistory = lastData;
    },
  },
});
